import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HomePage } from '../home/home.page';
import { MenuPage } from '../menu/menu.page';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { environment } from '../../../environments/environment';
import { Api } from 'src/smoothr-web-app-core/api/api';

@Component({
	selector: 'app-tos',
	templateUrl: './tos.page.html',
	styleUrls: ['tos.page.scss'],
	standalone: false,
})
export class TosPage {
	static url = 'tos';
	checkIfVenueExistImpressum: string;
	environment = environment;

	constructor(
		private repository: RepositoryService,
		private router: Router
	) {}

	static async navigate(router: Router) {
		await router.navigateByUrl(TosPage.url);
	}

	ionViewDidEnter() {
		if (this.repository._venue && this.repository._order) {
			if (this.repository._venue && this.repository._venue?.legal?.terms) {
				this.checkIfVenueExistImpressum = this.repository._venue?.legal?.terms;
			} else {
				this.checkIfVenueExistImpressum = '';
			}
		} else {
			this.checkIfVenueExistImpressum = '';
		}
		this.privacyLogic();
	}
	async privacyLogic() {
		let venue = this.repository._venue;
		try {
			if (!venue) {
				venue = await this.repository.getVenue(this.repository._order?.venue);
			}

			this.repository.venue.emit(venue);

			const response = (await Api.getLegal(venue._id)).data;
			if (response.privacy) {
				this.checkIfVenueExistImpressum = response.terms;
			}
		} catch (err) {
			console.error('imprint error!!!!', err);
		}
	}

	goBack() {
		if (this.repository._order === null) {
			HomePage.navigate(this.router);
		} else {
			MenuPage.navigate(this.router);
		}
	}
}
